import Repository from "@/repository";

const defaultEvent = {
  counterparty: "",
  date: "",
  status: "",
  event_type: "",
  purpose: "",
  event: "",
  responsible_manager: "",
};

export default {
  state: {
    events: [],
    event: JSON.parse(JSON.stringify(defaultEvent)),
    totalPages: 1,
    thisPage: 1,
    cities: [],
    regions: [],
    managers: [],
    interval: "",
    activeEvents: [],
  },
  actions: {
    async getEvents({ commit, rootState }, params) {
      const data = {
        size: 20,
        date_after: params.date_after,
        date_before: params.date_after,
        status: params.status,
        event_type: params.event_type,
        city: params.city,
        region: params.region,
        responsible_manager: params.responsible_manager,
        counterparty: params.counterparty,
      };
      if (!params.isNotLoad) {
        commit("setIsLoader", true);
      }

      const { value, error } = await Repository.EventsActions.get(data);
      if (!error) {
        commit("setEvents", value.data);
        commit("setTotalPages", value.total_pages);
        commit("setThisPage", value.page);
        commit("setEventsData", value);
        commit("watchEvents", rootState.auth.userId);
      }
      commit("setIsLoader", false);
    },
    async getEvent({ commit }, id) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.EventsActions.getOne(id);
      if (!error) {
        commit("setEvent", value);
      }
      commit("setIsLoader", false);
    },
    async createEvent({ commit, state }) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.EventsActions.create(
        state.event
      );
      if (error) {
        commit("setErrors", error);
        commit("setIsLoader", false);
        return false;
      }
      commit("resetEvent");
      commit("setIsLoader", false);
      return true;
    },
    async updateEvent({ commit, state }) {
      commit("setIsLoader", true);
      const payload = JSON.parse(JSON.stringify(state.event));

      console.log(payload);
      if (payload.counterparty.id) {
        delete payload.counterparty;
      }
      if (payload.responsible_manager.username) {
        delete payload.responsible_manager;
      }

      const { error } = await Repository.EventsActions.update(payload);
      if (error) {
        commit("setErrors", error);
        commit("setIsLoader", false);
        return false;
      }
      commit("setIsLoader", false);
      return true;
    },
    async deleteEvent({ commit }, id) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.EventsActions.delete(id);
      commit("setIsLoader", false);
    },
    async getManagers({ commit }) {
      const { value, error } = await Repository.UsersActions.get();
      if (!error) {
        commit("setMangers", value);
      }
    },
  },
  mutations: {
    setEventsField(state, { field, value }) {
      if (field.split(".").length > 1) {
        if (
          !(field.split(".")[0] in state.event) ||
          state.event[field.split(".")[0]] === null
        ) {
          state.event[field.split(".")[0]] = {};
        }
        state.event[field.split(".")[0]][field.split(".")[1]] = value;
      } else {
        state.event[field] = value;
      }
    },
    setEvents(state, value) {
      state.events = value;
    },
    setEvent(state, value) {
      state.event = value;
    },
    resetEvent(state) {
      state.event = JSON.parse(JSON.stringify(defaultEvent));
    },
    setTotalPages(state, value) {
      state.totalPages = value;
    },
    setThisPage(state, value) {
      state.thisPage = value;
    },
    setEventsData(state, value) {
      state.cities = value.cities;
      state.regions = value.regions;
      state.managers = value.managers;
    },
    setMangers(state, value) {
      state.managers = value;
    },
    removeActiveEvent(state, id) {
      state.activeEvents = state.activeEvents.filter((i) => i.id !== id);
    },
    watchEvents(state, userId) {
      clearInterval(state.interval);

      state.interval = setInterval(() => {
        let date = new Date().getTime();
        if (state.events.length) {
          state.events.forEach((i) => {
            let time = new Date(
              i.date.slice(0, -4).split("T").join(" ")
            ).getTime();
            if (
              (date - time) / 1000 / 60 <= 0.75 &&
              (date - time) / 1000 / 60 >= 0
            ) {
              if (i.responsible_manager.id === userId) {
                const audio = new Audio(
                  require("@/assets/sounds/new-order.wav")
                );
                audio.play();
                setTimeout(() => {
                  state.activeEvents.push(i);
                }, 1000);
              }
            }
          });
        }
      }, 30000);
    },
  },
};
